import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import * as FileSaver from "file-saver"
import _ from "lodash"
import moment from "moment"
import numeral from "numeral"
import helpers from "helpers/helpers"
import settings from "settings"
import { setTableExporting } from "actions"

//? leavePercents is to avoid having numeral flip raw float numbers to a percent down below.  Sometimes the percnts are already formatted, so this prop leaves them alone.

class ExcelExport extends Component {
	constructor(props) {
		super(props)
	}

	handle = async () => {
		let data
		if (this.props.excelClean) {
			data = this.props.excelClean(this.props.tableRef.getResolvedState().sortedData)
		} else {
			data = this.props.tableRef.getResolvedState().sortedData
		}
		let set = _.cloneDeep(data)
		let f = []
		// Remove react-table crud
		_.forEach(set, (v) => {
			let row = v
			if (v._original) {
				row = v._original
			}
			//? Manually remove columns from this.props.unset
			if (this.props.unset) {
				_.forEach(this.props.unset, (us) => {
					_.unset(row, us)
				})
			}
			_.forEach(row, (r, k) => {
				if (typeof r === "number" && k.toLowerCase().includes("date")) {
					row[k] = moment.unix(r).format("MM/DD/YY")
				} else if (typeof r === "number" && r > 946706400) {
					//! The number above is for 1/1/2000.  Numbers shouldn't ever get that high for prices and the like, so it's probably a timestamp.  Leaving a note in case this comes up.
					row[k] = moment.unix(r).format("MM/DD/YY")
				} else if (k && k.toLowerCase().includes("percent") && !this.props.leavePercents) {
					row[k] = numeral(r / 100).format("0.00%")
				} /* else if (r && typeof r !== "string" && !isNaN(r) && Number.isInteger(r)) {
					row[k] = numeral(r).format('0,0')
				} */ else if (
					["fee", "price", "amount"].some((v) => k.toLowerCase().includes(v)) &&
					(typeof r === "number" || parseInt(r) || parseFloat(r)) // If this a number, or a string that can be parsed to a number
				) {
					// Format fees, prices, and amounts that are numbers to currency
					let format = "$0,0.00"
					if (Number.isInteger(r) || parseInt(r)) format = "$0,0"
					// Commented out due to complaints that they cannot sum totals in excel.
					//row[k] = numeral(r).format(format)
				}
			})
			f.push(row)
		})
		// Rearrange the excel column order to match the columns
		let columns
		if (this.props.exportAllColumns) {
			columns = _.map(this.props.allColumns, (v) => v.accessor)
		} else if (this.props.hasColumnsGrouped) {
			//? This is for columns that have groupings, originally from detailed takedown report
			columns = []
			_.forEach(this.props.columns, (v) => {
				if (v.columns) {
					_.forEach(v.columns, (r) => {
						if (!r.gutter) columns.push(r.accessor)
					})
				} else {
					if (!v.gutter) columns.push(v.accessor)
				}
			})
		} else columns = _.map(this.props.columns, (v) => v.accessor)
		// Remove unsetted
		if (this.props.unset) _.remove(columns, (v) => this.props.unset.includes(v))

		let arranged = []
		columns = _.compact(columns)
		//? If something isn't ordering correctly, check that the title matches exactly.  E.g. Section ID vs Section Id
		_.forEach(f, (v) => {
			let row = {}
			_.forEach(columns, (column) => {
				row[column] = v[column]
			})
			// Now add any hidden columns that aren't on the table to the end.  So the order is whatever is the table, in order, then tack on the extra info that's on the tables sometimes.
			_.forEach(v, (r, key) => {
				if (!row.hasOwnProperty(key)) {
					// This checks if this row is a core column and if it's unselected, do not add.  So if you go to a table and unselect Primary First, it won't appear in the excel, however the "hidden" columns will still appear.
					if (
						_.find(this.props?.allColumns, { accessor: key }) &&
						!_.find(this.props?.columns, { accessor: key })
					)
						return
					row[key] = r
				}
			})
			arranged.push(row)
		})
		// end excel column order
		//return
		f = helpers.translateTable(arranged)

		// Run utils, if any
		//? Not in use, but could be useful.
		if (this.props.utils) {
			_.forEach(this.props.utils, (v) => {
				f = helpers[v](f)
			})
		}

		//return
		const { default: XLSX } = await import("xlsx")
		const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
		const fileExtension = ".xlsx"
		const ws = XLSX.utils.json_to_sheet(f)
		const wb = { Sheets: { data: ws }, SheetNames: ["data"] }
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
		const d = new Blob([excelBuffer], { type: fileType })
		let title = this.props.title
		if (!title) title = "Export"
		FileSaver.saveAs(d, `${settings.name}-` + title + fileExtension)
	}

	formatData = (data) => {
		// Run the data through ReactTable's Cell formatter, so we get $387,998 vs. 387998
		_.forEach(data.columns, (v) => {
			if (!v.Cell) {
				return
			}
			_.forEach(data.sortedData, (r) => {
				r.original = r._original
				r[v.accessor] = v.Cell({ value: r[v.accessor] })
			})
		})
		// Get rid of reactable shit
		_.forEach(data.sortedData, (v) => {
			_.forEach(v, (r, k) => {
				if (k.substr(0, 1) == "_" || k == "original") {
					delete v[k]
				}
			})
		})

		return data.sortedData
	}

	handleJPG = async (type) => {
		let pdfMake = await import("pdfmake/build/pdfmake")
		let pdfFonts = await import("pdfmake/build/vfs_fonts")
		pdfMake = pdfMake.default
		pdfFonts = pdfFonts.default
		pdfMake.vfs = pdfFonts.pdfMake.vfs
		let data, sorted
		let footer = []
		// Excelclean put in place because react elements won't render here, so instead of using the default data we're ingesting a custom array from the parent component.  See documents.js
		data = _.cloneDeep(this.props.tableRef.getResolvedState())
		sorted = _.map(data.sortedData, (v) => {
			let f = {}
			_.forEach(v._original, (r, k) => {
				// This is for react elements, like address on lot management.
				if (r && typeof r === "object" && r["$$typeof"] === Symbol.for("react.element") && r?.props?.children) {
					f[k] = r?.props?.children
				} else if (r && typeof r == "object") {
					_.forEach(r, (i, p) => {
						f[`${k}.${p}`] = i
					})
				} else {
					f[k] = r
				}
			})
			return f
		})
		if (this.props.excelClean) {
			sorted = this.props.excelClean(sorted)
		}
		let subTotalRowIndex = []
		// Row groups need to be sorted by the rowGroup specified, overrides order they had in react-table
		// This is the subtotal logic like used on builder performance.
		if (this.props.rowGroups) {
			let arr = []
			sorted = _.sortBy(sorted, this.props.rowGroups.field)
			let bucket = sorted[0][this.props.rowGroups.field]
			// RowGroupColumns is an object with zero values.  Pulled from the sortedData on data above.  See builder performance.
			let runningModel = _.clone(this.props.rowGroups.columns)
			let i = 0
			//console.log(sorted)
			_.forEach(sorted, (v, k) => {
				// if bucket isn't v.<type>, then it changed and we need to add a total row here.
				if (v[this.props.rowGroups.field] !== bucket) {
					runningModel[this.props.rowGroups.titleInField] = "Subtotal"
					runningModel.isSubtotal = true
					subTotalRowIndex.push(i)
					arr.push(runningModel)
					runningModel = _.cloneDeep(this.props.rowGroups.columns)
					bucket = v[this.props.rowGroups.field]
				}
				_.forEach(runningModel, (r, key) => {
					runningModel[key] += v[key]
				})
				arr.push(v)
				i++
			})
			subTotalRowIndex.push(i)
			arr.push({ ...runningModel, ...{ isSubtotal: true, [this.props.rowGroups.titleInField]: "Subtotal" } })
			//console.log(arr)
			sorted = arr
		}
		if (!sorted || sorted.length == 0) {
			return
		}
		let columns = []
		_.forEach(this.props.tableRef.state.columns, (v) => {
			if (v.columns) {
				_.forEach(v.columns, (r) => {
					let header = ""
					if (typeof r.Header == "function") header = r.name
					else header = r.Header
					columns.push({
						header: `${v.Header}-${header}` || r.name,
						accessor: r.accessor,
						formatter: r.Cell || false,
						footer: r.Footer || false,
						pdfValue: r.pdfValue || false,
					})
				})
			} else {
				let header = ""
				if (typeof v.Header == "function") header = v.name
				else header = v.Header
				columns.push({
					header: header || v.name,
					accessor: v.accessor,
					formatter: v.Cell || false,
					footer: v.Footer || false,
					pdfValue: v.pdfValue || false,
				})
			}
		})
		_.forEach(this.props.tableRef.state.columns, (v) => {
			if (v.columns) {
				_.forEach(v.columns, (r) => {
					if (r.hasOwnProperty("Footer")) {
						footer.push({
							text: r.Footer({ data: this.props.tableRef.state.sortedData }, true),
							style: "footer",
						})
					} else {
						footer.push({ text: "" })
					}
				})
			} else {
				if (v.hasOwnProperty("Footer")) {
					footer.push({
						text: v.Footer({ data: this.props.tableRef.state.sortedData }, true),
						style: "footer",
					})
				} else {
					footer.push({ text: "" })
				}
			}
		})

		const calculatePageSize = (columns) => {
			const baseWidth = type === "landscape" ? 841.89 : 595.28
			const baseHeight = type === "landscape" ? 595.28 : 841.89
			const totalContentWidth = columns.length * 100
			if (totalContentWidth > baseWidth - 40) {
				return {
					width: totalContentWidth + 40,
					height: baseHeight,
				}
			}
			return undefined
		}

		const pageSize = calculatePageSize(columns)

		let def = {
			pageOrientation: type,
			pageSize: pageSize,
			pageMargins: [20, 30, 20, 30],
			header: (currentPage, pageCount, pageSize) => {
				let properties = ""
				if (this.props.activeProperties.length > 0) {
					let props = []
					_.forEach(this.props.activeProperties, (v) => {
						let p = _.find(this.props.payload.public.properties, { id: parseInt(v) })
						if (p) props.push(p.name)
					})
					if (props.length > 0) {
						properties = props.join(", ")
						properties = _.trim(properties, ", ")
					}
				}
				if (properties) properties = `${properties} | `
				let text = `${this.props.title} | ${properties}Date of Report: ${moment().format(
					"MM/DD/YYYY"
				)} | Selected Date Range: ${this.props.currentDates.startText} - ${this.props.currentDates.endText}`
				if (sorted?.length > 0) {
					text += ` | Total Rows: ${sorted.length}`
				}
				return [
					{
						text,
						alignment: "left",
						fontSize: 7,
						margin: [20, 5],
					},
				]
			},
			content: [
				{
					style: "table",
					table: {
						headerRows: 1,
						widths: columns.map(() => "*"),
						body: [
							_.map(columns, (v) => {
								return { text: v.header, style: "header" }
							}),
							..._.map(sorted, (v) => {
								// rearrange by columns
								let ret = []
								_.forEach(columns, (r) => {
									if (r.pdfValue) {
										ret.push({
											text: v[r.pdfValue],
											value: v[r.pdfValue],
											style: v.isSubtotal ? "subTotalRow" : "row",
										})
									} else if (r.formatter) {
										// Formatter
										ret.push({
											text: r.formatter({ value: v[r.accessor] }, true),
											value: v[r.accessor],
											style: v.isSubtotal ? "subTotalRow" : "row",
										})
									} else {
										// No formatting
										//? pdfValue is in case there's a react element coming through, we can set the value to show on the pdf export to be another plain string.  See realtor report's state.realtorStats.
										let accessor = r.pdfValue || r.accessor
										ret.push({
											text: v[accessor],
											value: v[accessor],
											style: v.isSubtotal ? "subTotalRow" : "row",
										})
									}
								})
								return ret
							}),
							footer,
						],
					},
					layout: {
						fillColor: function (rowIndex, node, columnIndex) {
							return rowIndex % 2 === 0 ? "#E7E8E7" : null
						},
						vLineWidth: function (i) {
							return 0
						},
						hLineWidth: function (i) {
							return 0
						},
						paddingLeft: function (i, node) {
							return 4
						},
						paddingRight: function (i, node) {
							return 4
						},
						paddingTop: function (i, node) {
							return 2
						},
						paddingBottom: function (i, node) {
							return 2
						},
					},
				},
			],
			styles: {
				header: {
					fontSize: 9,
					bold: true,
					margin: [0, 0, 0, 10],
					fillColor: "#F0F1F0",
					color: settings.primaryColor,
				},
				table: {
					fontSize: 8,
					width: "100%",
				},
				subTotalRow: {
					fillColor: settings.primaryColor,
					color: "#FFFFFF",
					bold: true,
					margin: [0, 3, 0, 3],
				},
				row: {
					margin: [0, 1, 0, 1],
				},
				footer: {
					bold: true,
				},
				smallText: {
					fontSize: 8,
				},
			},
		}

		if (this.props.appendedText) {
			//! Used in MUD for example
			def.content.push(...this.props.appendedText)
		}

		let title = this.props.title
		if (!title) title = "Export"
		pdfMake.createPdf(def, null, null, pdfFonts.pdfMake.vfs).download(`${title}.pdf`)
	}

	render() {
		return (
			<div className="excel">
				<i
					className="fas fa-file-image"
					title="Export to PDF Portrait"
					data-html2canvas-ignore="true"
					onClick={() => this.handleJPG("portrait")}></i>
				<i
					className="fad fa-image"
					title="Export to PDF Landscape"
					data-html2canvas-ignore="true"
					onClick={() => this.handleJPG("landscape")}></i>
				<i className="fad fa-file-excel" title="Export to Excel" onClick={this.handle} />
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		activeProperties: state.activeProperties,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			setTableExporting,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ExcelExport)
